/**
 * 高性能列表组件 author:cxl
 */
import React, { FC } from 'react';
import { View, Text } from '@tarojs/components';
import VirtualList from '@tarojs/components/virtual-list';

interface IFListProps {
  itemData: Array<Object>;
  keyExtractor?: Function;
  renderItem?: Function;
  renderSeparator?: JSX.Element;
  renderNoneData?: JSX.Element;
  contentH?: number; // 列表的高度 (传值后开启虚拟化列表)
  itemH?: number; // 列表单项的高度 (传值后开启虚拟化列表)
}

const DefaultNoneData = () => (
  <View className="ace-flat-list-noneWrap">
    <Text>当前无数据</Text>
  </View>
);
const DefaultRenderItem = () => {};
const FlatList: FC<IFListProps> = ({
  itemData = [],
  keyExtractor = () => '',
  renderSeparator = <View />,
  renderItem = DefaultRenderItem,
  renderNoneData = <DefaultNoneData />,
  contentH = 0,
  itemH = 0,
}) => {
  const dataLen = itemData.length;

  const Row = React.memo(({ index, data }: any) => {
    const item = data[index];
    return <View key={keyExtractor(item)}>{renderItem(item)}</View>;
  });
  if (contentH > 0 && itemH > 0 && dataLen > 0) {
    return (
      <VirtualList height={contentH} width="100%" itemData={itemData} itemCount={dataLen} itemSize={itemH}>
        {Row}
      </VirtualList>
    );
  }
  return (
    <View className="ace-flat-list-wrap">
      {dataLen === 0 ? (
        renderNoneData
      ) : (
        <View>
          {itemData.map((item) => (
            <View key={keyExtractor(item)}>
              {renderItem(item)}
              {renderSeparator}
            </View>
          ))}
        </View>
      )}
    </View>
  );
};
export default FlatList;
